import { Box, Grid, Stack, Typography } from "@mui/material"
import { allColors } from "../../constants"
import ProcessCard from "../../components/card/ProcessCard"
import { images } from "../../assets"
import GlobalButton from "../../components/globalButton"

const PROCESS_DATA = [
    {
        step: "01",
        title: "Join exploration call",
        description: "Tell us more about your business on a discovery call. We’ll discuss team structure and approach, success criteria, timescale, budget, and required skill sets to see how we can help.",
        image: images.developmentServiceProcessImg1,
    },
    {
        step: "02",
        title: "Discuss solution and team structure",
        description: "In a matter of days, we will finalize your project specifications, agree on an engagement model, select and onboard your team.",
        image: images.developmentServiceProcessImg2,
    },
    {
        step: "03",
        title: "Get started and track performance",
        description: "Once we’ve agreed on milestones, we’ll immediately get to work. We’ll track progress, report updates, and continuously adapt to your needs.",
        image: images.developmentServiceProcessImg3,
    },
]


const Process = () => {
    return (
        <Box component={"section"}
            mt={{ xs: 4, sm: 6, md: 8 }}
            px={{ xs: 2, sm: 6, md: 8 }}
            id="development-process">
            <Typography
                textAlign="center"
                fontFamily="Raleway"
                fontWeight="400"
                color={allColors.jetBlack}
                fontSize={{ xs: "35px", md: "50px" }}
            >
                Our Process
            </Typography>

            <Grid mt={2} container spacing={2} alignItems="stretch">
                {PROCESS_DATA.map((process) => (
                    <Grid item xs={12} key={process.step} sx={{ display: "flex" }}>
                        <ProcessCard
                            step={process.step}
                            title={process.title}
                            description={process.description}
                            image={process.image}
                        />
                    </Grid>
                ))}
            </Grid>


            <Stack direction="row" justifyContent="center" alignItems="center" mt={2}>
                <GlobalButton
                    variant={"outlined"}
                    title="Lets Discuss"
                    handleClickBtn={() => {
                        document
                            .getElementById("development-service-contact-us")
                            ?.scrollIntoView({ behavior: "smooth", block: "start" });
                    }}
                    style={{
                        color: allColors.silverSand,
                        borderColor: allColors.silverSand,
                        borderRadius: "2px",
                        height: "50px",
                        width: { xs: "100%", md: "150px" },
                    }}
                    hoverProperties={{
                        borderColor: allColors.silverSand,
                        backgroundColor: "transparent",
                        color: allColors.silverSand,
                    }}
                />
            </Stack>
        </Box>
    )
}

export default Process;